@if (ss.isOpen()) {
    <div class="sider-overlay" (click)="closeSider()"></div>
}
<nz-sider nzWidth="300">
    <ul nz-menu nzMode="inline">
        @for (item of ms.menu(); track item.key) {
            @if (!!item.children) {
                <li
                    nz-submenu
                    [routerLinkActive]="'adspt-menu-item-selected'"
                    [nzDisabled]="
                        isSysAdminOnly() ? (item.permission === 'SYS-ADMIN' ? false : disableLinks()) : disableLinks()
                    "
                >
                    <span title
                        ><span class="nav-text a-fx-sc"
                            ><adspt-icon [name]="item.key" /><span
                                [innerHTML]="'navigation.' + item.key | translate"
                            ></span></span
                    ></span>
                    <ul>
                        @for (subItem of item.children; track subItem.key) {
                            <li
                                nz-menu-item
                                [routerLinkActive]="'adspt-menu-item-selected'"
                                [routerLinkActiveOptions]="{ exact: true }"
                            >
                                @if (subItem.app === 'APOLLO') {
                                    <a
                                        class="nav-text"
                                        [routerLink]="subItem.url"
                                        [queryParams]="subItem.queryParams"
                                        >{{ 'navigation.' + subItem.key | translate }}</a
                                    >
                                } @else {
                                    <a class="nav-text a-fx-sc" [href]="subItem.url">
                                        <span [innerHTML]="'navigation.' + subItem.key | translate"></span>
                                        @if (subItem.isBeta) {
                                            <span class="ant-badge ant-badge-not-a-wrapper"
                                                ><sup class="ant-scroll-number ant-badge-count ant-badge-multiple-words"
                                                    >beta</sup
                                                ></span
                                            >
                                        }
                                        @if (subItem.isExternal) {
                                            <adspt-icon name="open-new-tab" />
                                        }
                                    </a>
                                }
                            </li>
                        }
                    </ul>
                </li>
            } @else {
                <li
                    nz-menu-item
                    [routerLinkActive]="'adspt-menu-item-selected'"
                    [nzDisabled]="
                        isSysAdminOnly() ? (item.permission === 'SYS-ADMIN' ? true : disableLinks()) : disableLinks()
                    "
                >
                    @if (item.app === 'APOLLO') {
                        <a class="nav-text" [routerLink]="item.url" [queryParams]="item.queryParams">
                            <adspt-icon [name]="item.key" />{{ item.name }}</a
                        >
                    } @else {
                        <a class="nav-text" [href]="item.url"><adspt-icon [name]="item.key" />{{ item.name }}</a>
                    }
                </li>
            }
        }
    </ul>
</nz-sider>
